import React, { useContext, useEffect, useMemo, useState } from 'react';
import { QueryContext, SelectQueryBuilder2 } from '@sierralabs/query-ui';
import { useConfigComponent } from '../hooks/component/useConfigComponent';
export const SiteConfigChart = props => {
    var _a;
    const { component: initialComponent, plugin } = props;
    const { component, update } = useConfigComponent(initialComponent);
    const [queryManager, setQueryManager] = useState();
    const { queryBuilderPlugins } = useContext(QueryContext);
    const plugins = useMemo(() => {
        return queryBuilderPlugins.some(p => p.type === plugin.type)
            ? queryBuilderPlugins
            : queryBuilderPlugins.concat(plugin);
    }, [plugin, queryBuilderPlugins]);
    useEffect(() => {
        if (!queryManager)
            return;
        const addDefaultChartPlugin = () => {
            var _a, _b;
            // add pluginConfig if it is not yet included
            const exists = (_b = (_a = queryManager.query.config) === null || _a === void 0 ? void 0 : _a.pluginConfigs) === null || _b === void 0 ? void 0 : _b.some(pluginConfig => pluginConfig.type === plugin.type);
            if (!exists) {
                queryManager.addPluginConfig({ type: plugin.type, params: {} });
            }
        };
        queryManager.subscribe('fromChange', addDefaultChartPlugin);
        return () => {
            queryManager.unsubscribe('fromChange', addDefaultChartPlugin);
        };
    }, [queryManager, plugin]);
    return (React.createElement(SelectQueryBuilder2, { plugins: plugins, query: (_a = component.props) === null || _a === void 0 ? void 0 : _a.query, onSetQueryManager: setQueryManager, onChange: query => update('props.query', query) }));
};
export default SiteConfigChart;
//# sourceMappingURL=SiteConfigChart.js.map